import React from 'react';
import './logo.scss';
export default function Logo() {
    return (React.createElement("span", { className: "logo-wrapper" },
        React.createElement("span", { className: "logo" },
            React.createElement("a", { href: "/", "aria-label": "Home Page", "data-analytics-link": true },
                React.createElement("img", { className: "logo-color", src: "/dist/images/logo.svg", alt: "OpenStax logo", width: "354", height: "81" }),
                React.createElement("img", { className: "logo-white", src: "/dist/images/logo-white.svg", alt: "OpenStax logo" }))),
        React.createElement("span", { className: "logo-quote" }, "Access. The future of education.")));
}
